import BookAuthorsList from 'components/BookCard/BookAuthorsList'
import Heading from 'components/common/Heading'
import { GoCalendar } from 'react-icons/go';
import { GiWeightScale, GiWhiteBook, GiBookmark } from 'react-icons/gi';
import LabeledData from 'components/common/LabeledData';
import Image from 'components/common/Image';
import getBookCoverUrl from 'utils/bookCoverUrl';
import classnames from 'utils/classnames';

const BookData = ({ data: { title, authors, publish_date, physical_format, number_of_pages, weight, covers = [] }, className, ...rest }) => {
    const bookCoverUrl = getBookCoverUrl(covers[0]);

    const classNames = classnames('overflow-y-auto', className);

    return (
        <article className={classNames} {...rest}>
            <Heading>
                { title }
            </Heading>

            <div className="mt-4 flex">
                <div className="w-1/3 h-60 mr-4">
                    <Image src={bookCoverUrl} className="object-contain" />
                </div>

                <div className="grid grid-cols-2 gap-8 h-fit">
                    { authors?.length > 0 && <BookAuthorsList authors={authors} /> }

                    {
                        publish_date && (
                            <LabeledData label="Release date">
                                <p className="flex items-center">
                                    <GoCalendar className="mr-1" />
                                    { publish_date }
                                </p>
                            </LabeledData>
                        )
                    }

                    {
                        physical_format && (
                            <LabeledData label="Physical format">
                                <p className="flex items-center">
                                    <GiWhiteBook className="mr-1" />
                                    { physical_format }
                                </p>
                            </LabeledData>
                        )
                    }

                    {
                        number_of_pages && (
                            <LabeledData label="Number of pages">
                                <p className="flex items-center">
                                    <GiBookmark className="mr-1" />
                                    { number_of_pages }
                                </p>
                            </LabeledData>
                        )
                    }

                    {
                        weight && (
                            <LabeledData label="Weight">
                                <p className="flex items-center">
                                    <GiWeightScale className="mr-1" />
                                    { weight }
                                </p>
                            </LabeledData>
                        )
                    }
                </div>
            </div>

        </article>
    )
}

export default BookData